module.exports = __webpack_public_path__ + "static/DailyBrief-52429005ed37365b11f1681cb6a17f75.png";